import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { usePromotionsStore } from 'src/store/benefits/promotions.store';

export default function usePromotionsList() {
  const navigate = useNavigate();
  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'endDate', label: 'Data Fim', type: 'date' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  const { getPromotionsList, isLoadingPromotionsList, promotionsList } = usePromotionsStore();

  useEffect(() => {
    getPromotionsList();
  }, []);

  return {
    TABLEHEADER,
    isLoadingPromotionsList,
    promotionsList,
    navigate,
  };
}
